module.exports = __webpack_public_path__ + "static/media/conference_15.416bcc2e.jpg";